<script setup lang="ts">
import { VImg } from '@hatfieldmedia/hmcore'

const navLinks = [
  { label: 'Events', href: '#events' },
  { label: 'Services', href: '#services' },
  { label: 'Benefits', href: '#benefits' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Instagram', href: 'https://www.instagram.com/m6performancetraining', external: true },
  { label: 'Facebook', href: 'https://www.facebook.com/mpower6gym', external: true },
]

function scrollTo(event: Event, href: string) {
  event.preventDefault()
  const target = document.querySelector(href)
  target?.scrollIntoView({ behavior: 'smooth' })
}
</script>

<template>
  <footer class="site-footer">
    <VImg src="/media/images/logo.png" class="foot-logo" :height="32" />
    <nav aria-label="Footer navigation">
      <ul class="footer-links">
        <li v-for="link in navLinks" :key="link.href">
          <a
            :href="link.href"
            v-bind="link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {}"
            @click="!link.external && scrollTo($event, link.href)"
          >{{ link.label }}</a>
        </li>
      </ul>
    </nav>
    <client-only>
      <p>&copy; {{ new Date().getFullYear() }} M6 Elite Combine Testing. All rights reserved.</p>
    </client-only>
  </footer>
</template>

<style scoped>
.site-footer {
  background: var(--darker);
  padding: 40px 48px 40px;
  text-align: center;
}

.foot-logo {
  height: 32px;
  width: auto;
  margin: 0 auto 20px;
  display: block;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 20px;
  list-style: none;
  padding: 0;
}

.footer-links a {
  color: var(--text);
  text-decoration: none;
  font-family: 'HND', sans-serif;
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  transition: color 0.25s;
}

.footer-links a:hover {
  color: var(--pink-bright);
}

p {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.35);
  margin: 0;
}

@media (max-width: 768px) {
  .site-footer {
    padding: 20px 18px 28px;
  }

  .footer-links {
    flex-wrap: wrap;
    gap: 16px;
  }

  .footer-links a {
    font-size: 0.75rem;
  }

  p {
    font-size: 0.72rem;
  }

  .foot-logo {
    height: 26px;
  }
}
</style>
